type Crop = any;

export class CropService {
    public crops: Crop[];
    public viewer: any;

    constructor() {
        this.crops = [];
        this.viewer = window.viewer;
    }

    addCrop(crop: Crop) {
        //console.log('addCrop:', crop);

        if (!crop.uuid) {
            let uuid = PSPCustomization.pspUtils.GetNewGuid();
            crop.uuid = uuid;
        }
        crop.isCrop = true;

        this.crops.push(crop);
        this.viewer.scene.dispatchEvent({
            type: 'crop_added',
            scene: this.viewer.scene,
            crop: crop,
        });
    }

    removeCrop(crop: Crop) {
        let index = this.crops.indexOf(crop);
        if (index > -1) {
            this.crops.splice(index, 1);
            this.viewer.scene.dispatchEvent({
                type: 'crop_removed',
                scene: this.viewer.scene,
                crop: crop,
            });
        }
    }
}
